import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { createIntl } from "@formatjs/intl/lib/src/create-intl";
import React, { createContext, useContext, useMemo } from "react";
import { DEFAULT_LOCALE_KEY } from "../consts/DEFAULT_LOCALE";
import { createFormatMessage } from "./createFormatMessage";
import { buildLocale } from "./utils";
var getFormatMessage = function(localeKey, formatMessage) {
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID || (localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
        return createFormatMessage(localeKey, formatMessage);
    }
    return formatMessage;
};
var buildIntl = function(param) {
    var localeKey = param.localeKey, messages = param.messages;
    var locale = buildLocale(localeKey !== null && localeKey !== void 0 ? localeKey : DEFAULT_LOCALE_KEY);
    var intl = createIntl({
        locale: locale,
        defaultLocale: locale,
        messages: messages
    });
    var formatMessage = getFormatMessage(localeKey, intl.formatMessage);
    return _object_spread_props(_object_spread({}, intl), {
        formatMessage: formatMessage
    });
};
var DEFAULT_INTL = buildIntl({
    localeKey: DEFAULT_LOCALE_KEY,
    messages: {}
});
var DEFAULT_STORE = {
    intl: buildIntl({
        localeKey: DEFAULT_LOCALE_KEY,
        messages: {}
    }),
    shouldPassThrough: false,
    localeKey: DEFAULT_LOCALE_KEY,
    currencyFormatLocale: DEFAULT_INTL.locale,
    intlForCurrency: DEFAULT_INTL
};
var LocalizationContext = /*#__PURE__*/ createContext(DEFAULT_STORE);
export var LocalizationProvider = function(param) {
    var children = param.children, localeKey = param.localeKey, currencyFormatLocale = param.currencyFormatLocale, shouldPassThrough = param.shouldPassThrough;
    var initialValue = useMemo(function() {
        var value = _object_spread({}, DEFAULT_STORE);
        var _ref;
        value.localeKey = (_ref = localeKey !== null && localeKey !== void 0 ? localeKey : getGlobalProperty("localeKey")) !== null && _ref !== void 0 ? _ref : value.localeKey;
        value.shouldPassThrough = shouldPassThrough !== null && shouldPassThrough !== void 0 ? shouldPassThrough : value.shouldPassThrough;
        value.intl = value.localeKey ? buildIntl({
            localeKey: value.localeKey,
            messages: {}
        }) : value.intl;
        var _ref1, _ref2;
        value.currencyFormatLocale = (_ref2 = (_ref1 = currencyFormatLocale !== null && currencyFormatLocale !== void 0 ? currencyFormatLocale : getGlobalProperty("currencyFormatLocale")) !== null && _ref1 !== void 0 ? _ref1 : value.currencyFormatLocale) !== null && _ref2 !== void 0 ? _ref2 : value.intl.locale;
        value.intlForCurrency = value.currencyFormatLocale !== value.intl.locale ? createIntl({
            locale: value.currencyFormatLocale,
            messages: {}
        }) : value.intl;
        return value;
    }, [
        currencyFormatLocale,
        localeKey,
        shouldPassThrough
    ]);
    return /*#__PURE__*/ _jsx(LocalizationContext.Provider, {
        value: initialValue,
        children: children
    });
};
export var useLocalization = function() {
    return useContext(LocalizationContext);
};
